/*
 * File: App.js
 * Project: frontend
 * File Created: Monday, 1st May 2023 5:07:21 pm
 * Author: Sharath Puranik (sharath.puranik@stylumia.com)
 * -----
 * Last Modified: Friday, 30th August 2024 4:59:20 pm
 * Modified By: Sharath Puranik (sharath.puranik@stylumia.com>)
 * -----
 * Copyright - 2024, Stylumia Intelligence Technology Pvt Ltd
 */

import React from "react";

import AuthRoutes from "./AuthRoutes/AuthRoutes";

function App() {
  return (
    <div className="App">
      <AuthRoutes />
    </div>
  );
}

export default App;
